import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import PolyBackground from "@/components/PolyBackground";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Industries from "@/pages/Industries";
import Contact from "@/pages/Contact";

function App() {
    return (
        <HelmetProvider>
            <PolyBackground />
            <div className="App text-foreground">
                <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main className="min-h-[60vh]">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/team" element={<Team />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/industries" element={<Industries />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster
                    position="top-center"
                    toastOptions={{
                        style: {
                            background: "#1A3626",
                            color: "#FAF9F6",
                            border: "1px solid rgba(217,138,44,0.4)",
                        },
                    }}
                />
            </BrowserRouter>
            </div>
        </HelmetProvider>
    );
}

export default App;
